











































































import { SiteState, UserNavItem, UserState } from "@/store/types";
import { Component, Watch, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import {
  authenticate,
  registerUser,
  requestReset,
  resetPassword,
  getResetUser,
} from "../api/methods";
import { mayRegister, enableForgotten } from "@/.config";
import { bus } from "@/main";
import { notEmptyString, validEmail, validPassword } from "../api/validators";
import SnippetItem from "./widgets/SnippetItem.vue";
import { formatDate } from "@/api/helpers";

@Component({
  components: {
    SnippetItem,
  },
  filters: {},
})
export default class Login extends Vue {
  @State("site") site: SiteState;
  @State("user") user: UserState;
  @Action("assignUser", { namespace: "user" }) assignUser: any;
  @Action("assignSubmission", { namespace: "submission" })
  assignSubmission: any;

  private email = "";

  private password = "";

  private cpassword = "";

  private firstName = "";

  private lastName = "";

  private error = false;

  private msg = "";

  private mode = "login";

  private msgPos = 'bottom';

  private resetHash = "";

  private isOpen = false;

  private applicationsOpen = false;

  private activeTab = 0;

  private showFields = true;

  private modes: Array<UserNavItem> = [
    { key: "login", name: "Login", inNav: true },
    { key: "register", name: "Register", inNav: true },
    { key: "forgotten", name: "Forgotten password", inNav: true },
    { key: "reset", name: "Reset your password", inNav: false },
  ];

  created() {
    this.setMode(true);
    if (this.mode === "reset") {
      const { path, hash } = this.$route;
      const [first, second] = path.split("reset/");
      if (second) {
        this.resetHash = second.split("/").shift();
      } else if (notEmptyString(hash)) {
        this.resetHash = hash
          .split("reset/")
          .shift()
          .replace(/^#/, "");
      }
      if (notEmptyString(this.resetHash)) {
        getResetUser(this.resetHash).then(result => {
          if (result instanceof Object && Object.keys(result).includes('identifier')) {
            const { identifier } = result;
            this.msg = this.site.label('password_reset_prompt') + ` ${identifier}`;
            this.msgPos = 'top';
          }
        });
      }
    }
    this.sync();
    bus.$on("checked-status", this.sync);
  }

  sync() {
    this.isOpen = this.site.setting("submissions_open");
    const deadlineTs = new Date(
      this.site.setting("submissions_deadline")
    ).getTime();
    const nowTs = new Date().getTime();
    this.applicationsOpen = nowTs < deadlineTs;
  }

  get mayLogin() {
    return this.isOpen;
  }

  get mayRegister() {
    return this.mayLogin && this.applicationsOpen && mayRegister;
  }

  get introSnippetKey() {
    // artists may start and submit application without deadlines
    if (this.isOpen && this.applicationsOpen) {
      return "public_introduction";
    } else if (this.isOpen) {
      // The form is accessible in read-only review mode or
      // for candidates with deadline extensions
      return "public_extended_message";
    } else {
      return "public_offline_message";
    }
  }

  filterMode(mode: UserNavItem) {
    const {path} = this.$route;
    const pathParts = path.substring(1).split("/");
    switch (mode.key) {
      case "register":
        return mode.inNav && this.mayRegister;
      case "login":
        return mode.inNav && this.mayLogin;
      case "forgotten":
        return mode.inNav && this.mayLogin && enableForgotten;
      case "reset":
        return pathParts.length > 1;
      default:
        return mode.inNav;
    }
  }

  get showPasswordHelp() {
    return ["reset","register"].includes(this.mode);
  }

  get modeNavItems() {
    return this.modes.filter(this.filterMode).map((md) => {
      return { ...md, link: "/" + md.key };
    });
  }

  get showEmail() {
    return this.mode !== "reset" && this.showFields;
  }

  get showPassword() {
    return this.mode !== "forgotten" && this.showFields;
  }

  get showConfirm() {
    return ["register","reset"].includes(this.mode) && this.showFields;
  }

  get fullName() {
    return [this.firstName, this.lastName].join(" ");
  }

  get isForgotten() {
    return this.mode === "forgotten";
  }

  get isReset() {
    return this.mode === "reset";
  }

  get showFullName() {
    return this.mode === "register" && this.mayRegister && this.showFields;
  }

  get showMessageTop() {
    return notEmptyString(this.msg, 3) && this.msgPos === 'top' && !this.error;
  }

  get showMessageBottom() {
    return notEmptyString(this.msg, 3) && this.msgPos === 'bottom'  && !this.error;
  }

  setMode(setTab = false) {
    const { path } = this.$route;
    const key = path
      .substring(1)
      .split("/")
      .shift();
    switch (key) {
      case "login":
      case "register":
      case "forgotten":
      case "reset":
        this.mode = key;
        break;
    }
    if (setTab) {

    setTimeout(() => {
      this.activeTab = this.modeNavItems.findIndex(item => item.key === key);
    }, 500);
    }
  }

  get submitLabel() {
    switch (this.mode) {
      case "login":
        return "Login";
      case "register":
        return "Register";
      case "forgotten":
        return "Submit reset request";
      case "reset":
        return "Update password";
      default:
        return "Submit";
    }
  }

  submit() {
    let msg = "";
    this.msg = "";
    let valid = false;
    if (this.showEmail) {
      if (notEmptyString(this.email) && validEmail(this.email)) {
        valid = true;
      } else {
        msg = "Please enter a valid email";
        valid = false;
      }
    }
    if (this.showPassword) {
      if (validPassword(this.password, 8, "loose")) {
        valid = true;
      } else {
        const errorKey = this.password.length < 8? 'password_minlength_message' : 'password_invalid_format_message';
        msg = this.site.label(errorKey);
        valid = false;
      }
    }
    if (this.showConfirm) {
      if (notEmptyString(this.cpassword)) {
        valid = this.password === this.cpassword;
      } else {
        msg = this.site.label('passwords_not_match_message');
        valid = false;
      }
    }
    if (this.showFullName) {
      if (
        notEmptyString(this.firstName, 1) &&
        notEmptyString(this.lastName, 1)
      ) {
        valid = true;
      } else {
        msg = "Please enter your full name";
        valid = false;
      }
    }
    if (valid) {
      switch (this.mode) {
        case "login":
          this.loginLocal();
          break;
        case "register":
          this.register();
          break;
        case "reset":
          this.sendReset();
          break;
        case "forgotten":
          this.sendResetRequest();
          break;
      }
    } else {
      this.msg = msg;
      this.error = true;
    }
  }

  matchMode(type: string) {
    return this.mode === type ? "is-link" : "is-link-light";
  }

  signIn(data) {
    const { submission, token, setPassword } = data;
    const userMap: Map<string, any> = new Map();
    Object.entries(data).forEach((entry) => {
      const [key, value] = entry;
      switch (key) {
        case "valid":
        case "submission":
          break;
        default:
          userMap.set(key, value);
          break;
      }
    });
    const userObj = Object.fromEntries(userMap);
    this.$ls.set("user", userObj);
    this.$ls.set("submission", submission);
    this.assignUser(userObj);
    this.assignSubmission(submission);
    const { path } = this.$route;
    if (setPassword && notEmptyString(token)) {
      this.$router.push("/reset/first-time-login");
      this.showFields = false;
      setTimeout(() => {
        this.mode = 'reset';
        this.activeTab = 2;
        this.resetHash = token;
        this.showFields = true;
      }, 250);
    } else {
      if (path !== "/" && path.length > 2) {
        this.$router.push("/");
      }
    }
    bus.$emit("login", true);
  }

  loginLocal() {
    this.error = false;
    if (this.mayLogin) {
      authenticate(this.email, this.password).then((data) => {
        if (data instanceof Object && data.valid) {
          const { programmeOpen, programmeDeadline } = data;
          if (programmeOpen === false && notEmptyString(programmeDeadline)) {
            const strDate = formatDate(programmeDeadline, "dd/MM/yyyy HH:mm");
            this.msg = [this.site.label("programme_deadline_expired"), strDate.split(" ").join(" at ")].join(" ");
            this.error = true;
          } else {
            this.signIn(data);
          }
        } else {
          const {msg} = data;
          this.msg = notEmptyString(msg, 4)? msg : this.site.label("invalid_username_or_password");
          this.error = true;
        }
      });
    }
  }

  register() {
    this.error = false;
    if (this.mayRegister) {
      const params = {
        identifier: this.email,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName,
      };
      registerUser(params).then((data) => {
        if (data instanceof Object && data.valid) {
          this.signIn(data.user);
        }
      });
    }
  }

  sendResetRequest() {
    requestReset(this.email).then(data => {
      this.msgPos = 'bottom';
      if (data.valid) {
        this.msg = this.site.label('sent_reset_email') + ` (${this.email})`;
      } else {
        this.msg = this.site.label('email_not_matched') + ` (${this.email})`;
        this.error = true;
      }
    });
  }

  sendReset() {
    const params = {
      email: this.email,
      password: this.password,
    };
    this.error = false;
    const hash = this.resetHash;
    resetPassword(hash, params).then((data) => {
      if (data instanceof Object && data.valid) {
        this.signIn(data);
      } else {
        this.msg = data.msg;
        this.error = true;
      }
    });
  }

  @Watch("$route")
  changeRoute() {
    this.setMode();
  }

  @Watch("activeTab")
  changeActiveTab(newVal) {
    const row =
      newVal >= 0 && newVal < this.modeNavItems.length
        ? this.modeNavItems[newVal]
        : 0;
    if (row instanceof Object) {
      if (this.error) {
        this.msg = "";
        this.error = false;
      }
      const { path } = this.$route;
      const pathParts = path.substring(1).split("/");
      const newParts = [row.key];
      if (pathParts.length > 1) {
        newParts.push(pathParts[1]);
        this.showFields = false;
        setTimeout(() => {
          this.showFields = true;
        }, 125);
      }
      const newPath = "/" + newParts.join("/");
      if (newPath !== path) {
        this.$router.push(newPath);
      }
      this.mode = row.key;
    }
  }
}
